import axios from 'axios';
import { filterHeaderInterceptor } from './filter-header.interceptor';
import { requestInterceptor } from './request.interceptor';
import { responseErrorInterceptor } from './response-error.interceptor';
import { responseInterceptor } from './response.interceptor';

export const setupInterceptors = () => {
  axios.interceptors.request.use(filterHeaderInterceptor);
  axios.interceptors.request.use(requestInterceptor);
  axios.interceptors.response.use(
    responseInterceptor,
    responseErrorInterceptor,
  );
};
